import { useCallback } from 'react';
import PropTypes from 'prop-types';
import Table from '@mui/material/Table';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { isEmpty } from 'ramda';
import { useDispatch, useSelector } from 'react-redux';

import { getLabelMessage } from '@gef-ui/localization/messages';

import { ComponentLoader } from 'components';
import PaginationRow from 'components/atoms/GefMui/PaginationRow';
import SortCell from 'components/atoms/GefMui/SortCell';
import fetch from 'features/common/fetch';
import taskSearch from 'features/views/taskSearch';

import ResultsTableBody from './ResultsTableBody';

export const ResultsTable = () => {
	const dispatch = useDispatch();

	const sort = useSelector(taskSearch.selectors.getSort);
	const tasks = useSelector(taskSearch.selectors.getTasks);
	const hasRecords = !isEmpty(tasks);

	const handlePaginationClick = useCallback(
		(e, page) => {
			dispatch(taskSearch.actions.paginationClick(page - 1));
		},
		[dispatch],
	);

	const handleSort = useCallback(
		(sort) => {
			dispatch(taskSearch.actions.loadSorted(sort));
		},
		[dispatch],
	);

	const handleReload = useCallback(() => {
		dispatch(taskSearch.actions.reload());
	}, [dispatch]);

	const handleLoadMore = useCallback(() => {
		dispatch(taskSearch.actions.loadMore());
	}, [dispatch]);

	return (
		<ComponentLoader fetchStorePath={fetch.constants.urls.taskList} onReload={handleReload}>
			<Table size="small">
				<TableHead>
					<TableRow>
						<TableCell />
						<TableCell>
							<div>{getLabelMessage('taskSearch:taskId')} </div>
							<div>{getLabelMessage('taskSearch:taskState')}</div>
						</TableCell>
						<TableCell>
							<div>{getLabelMessage('taskSearch:clientName')}</div>
							<div>{getLabelMessage('taskSearch:municipality')}</div>
						</TableCell>
						<TableCell>{getLabelMessage('taskSearch:policyNo')}</TableCell>
						<TableCell>
							<div>{getLabelMessage('taskSearch:taskType')}</div>
							<div>{getLabelMessage('taskSearch:taskFinishType')}</div>
						</TableCell>
						<TableCell>{getLabelMessage('taskSearch:solver')}</TableCell>
						<TableCell>
							<SortCell hasRecords={hasRecords} sortBy="createDate" sort={sort} onSort={handleSort}>
								{getLabelMessage('taskSearch:taskCreationDate')}
							</SortCell>
							<div>{getLabelMessage('taskSearch:taskDeadlineDate')}</div>
						</TableCell>
						<TableCell />
					</TableRow>
				</TableHead>
				<ResultsTableBody />
				<PaginationRow
					fetchStorePath={fetch.constants.urls.taskList}
					colSpan={100}
					onLoadNext={handleLoadMore}
					onPaginationClick={handlePaginationClick}
					hideOnResultsLimit
				/>
			</Table>
		</ComponentLoader>
	);
};

ResultsTable.propTypes = {
	finishTypesAllCodelist: PropTypes.array,
	taskStatusCodelist: PropTypes.array,
	taskTypesCodelist: PropTypes.array,
};

export default ResultsTable;
